import { render, staticRenderFns } from "./InsertEmptyChapter.vue?vue&type=template&id=4a6c721a&scoped=true&"
import script from "./InsertEmptyChapter.vue?vue&type=script&lang=js&"
export * from "./InsertEmptyChapter.vue?vue&type=script&lang=js&"
import style0 from "./InsertEmptyChapter.vue?vue&type=style&index=0&id=4a6c721a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6c721a",
  null
  
)

export default component.exports